module.exports = __webpack_public_path__ + "media/images/emblems/Beromuenster_LU-88056d4e94657d749b2b0c95f000bbc0.png";